import * as categoryConf from 'confs/category_conf.json';
import { Fragment } from 'react';

const createCategorySelect = () => {

    let rtn = []

    categoryConf.categories.forEach((obj) => {
        rtn.push( <option key={obj.category} value={obj.category}>{obj.label}</option> );
    })

    return (
        <Fragment>{ rtn }</Fragment>
    );
};

export default createCategorySelect;